import { SafeJSON } from './../../shared/safe-json';

export class ConsolidatedCase {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
    }
    getKey(): string {
        return this.key;
    }
    getConsolidationOrderClockDate(): any {
        return SafeJSON.get('dispositionClockDate', this.json);
    }
    getConsolidationCaseCounty(): any {
        return SafeJSON.getWithDefault('caseNumber.county', this.json);
    }
    getConsolidationCaseNumber(): any {
        return SafeJSON.get('caseNumber.fileNumber', this.json);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/consolidatedCase.ts